/**
 * Created by Bart Decorte
 * Date: 2019-08-26
 * Time: 18:08
 */
import TablesShowElementDrag from './TablesShowElementDrag';
import Matrix from '../../../matrix/Matrix';

export default class TablesShowMatrix extends Matrix(TablesShowElementDrag) {
  constructor(params) {
    super(params);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Tables/_partials/TablesShowMatrix.js